import { Box, Button, Modal, Typography } from "@material-ui/core";
import React from "react";

export default function ({ errorModal, setErrorModal, message }) {
  const replaceNewlinesWithBreaks = (text) => {
    if (typeof text == "string") {
      const lines = text.split("\n");
      return lines.map((line, index) => (
        <React.Fragment key={index}>
          {line}
          <br />
        </React.Fragment>
      ));
    } else {
      return text;
    }
  };
  return (
    <Modal
      open={errorModal}
      onClose={() => {
        setErrorModal(false);
      }}
      aria-labelledby="simple-modal-title"
      aria-describedby="simple-modal-description"
    >
      <Box className="modal-wrapper">
        <Box className="modal">
          {/* <div className="modal-heading">
            <div className="modal-heading-text">
              <Typography className="modal-title" style={{ color: "#1B4484" }}>
                確認
              </Typography>
            </div>
            <button className="back-btn" onClick={() => setErrorModal(false)}>
              閉じる
            </button>
          </div> */}
          <div className="modal-body-wrapper">
            <Typography style={{ fontSize: "1.2rem", fontWeight: "600" }}>
              {replaceNewlinesWithBreaks(message)}
            </Typography>
            <button
              className="secondary-btn"
              onClick={() => {
                setErrorModal(false);
              }}
            >
              閉じる
            </button>
          </div>
        </Box>
      </Box>
    </Modal>
  );
}
